/**
 * workflow-core
 *
 * Copyright (c) Ballerine
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
var raise = function raise(error, cause) {
  throw typeof error === 'string' ? new Error(error, {
    cause: cause
  }) : error;
};

export { raise };
//# sourceMappingURL=raise.js.map
